
// Actions
import { start, error, warning, info, success, end, progress } from 'REDUCERS/connectivitySlice'
import { permissionsSuccess } from 'REDUCERS/appSlice';

// Utils
import connectivityCheck from 'CHECKS/connectivity/connectivityCheck';
import { PENDING } from 'UTILS/constants';

export default store => next => action => {
  switch (action.type) {
    case permissionsSuccess.toString(): {
      next(action);
      if (store.getState().checks.connectivity.stage === PENDING) {
        return store.dispatch(start());
      }
      return;
    }
    case start.toString(): {
      next(action);
      const relayServers = store.getState().app.relayServers;
      return connectivityCheck.start({
        onError: (type, data) => store.dispatch(error({ type, data })),
        onWarning: (type, data) => store.dispatch(warning({ type, data })),
        onInfo: (type, data) => store.dispatch(info({ type, data })),
        onSuccess: (type, data) => store.dispatch(success({ type, data })),
        onProgress: (value) => store.dispatch(progress({ value })),
        onEnd: (results) => store.dispatch(end({ ...results })),
        relayServers,
        logger: store.getState().app.isVerbose ? console : undefined,
      });
    }
    default:
      return next(action);
  }
};
